import { createSlice } from "@reduxjs/toolkit";
const getInitialTheme = () => {
  try {
    if (typeof window !== "undefined") {
      const stored = window.localStorage.getItem("theme");
      if (stored === "light" || stored === "dark") {
        return stored;
      }
      if (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches) {
        window.localStorage.setItem("theme", "dark");
        return "dark";
      }
      window.localStorage.setItem("theme", "light");
      return "light";
    }
  } catch (e) {
    console.error(e);
  }
  return "dark";
};
const themeSlice = createSlice({
  name: "theme",
  initialState: { mode: getInitialTheme() },
  reducers: {
    setTheme: (state, action) => {
      state.mode = action.payload;
      try {
        if (typeof window !== "undefined") {
          window.localStorage.setItem("theme", action.payload);
        }
      } catch (e) {
        console.error(e);
      }
    }
  }
});
const { setTheme } = themeSlice.actions;
var stdin_default = themeSlice.reducer;
export {
  stdin_default as default,
  setTheme
};
